import moment from 'moment';

const setDateTime = () => {
  let dateTime = new Date();
  dateTime = moment(dateTime).format('DD/MM/YYYY HH:mm.ss');
  return dateTime;
};

export default setDateTime;
